import React from 'react';
import { observer } from 'mobx-react';

import { HomeNavbar } from '../../common/home-navbar';
import styles from './RecoverAccount.css';
import { SessionStore } from '../../stores/SessionStore';
import { AppRedirect, routeNaming } from '../../routes';
import { constants } from '../../config/constants';
import { SEO } from '../../common/seo';
// import { DataForm } from './data-form';

const RecoverAccount = observer(() => {
  if (SessionStore.loggedIn) {
    return (
      <AppRedirect routeName={routeNaming.HOME} />
    );
  }
  return (
    <div className={styles.container}>
      <SEO
        title="Recuperar cuenta"
        description="¿No puedes acceder a tu cuenta? No te preocupes, puedes recuperarla rápidamente en [nombre de tu sitio web]. Simplemente ingresa tu correo electrónico registrado y te enviaremos un enlace para restablecer tu contraseña de manera segura. Recupérala en pocos pasos y vuelve a disfrutar de todos nuestros servicios. Si tienes alguna duda o problema, nuestro equipo de soporte está listo para ayudarte en todo momento. ¡Recupera el acceso a tu cuenta y continúa tu experiencia sin interrupciones!"
        type="website"
      />
      <HomeNavbar />
      <div className={styles.mainContent}>
        <h1 className={styles.title}>Recuperar cuenta</h1>
        <p className={styles.instructions}>
          Si no tenés acceso al email con el que te registraste
          podés recuperar tu cuenta así.
          <br />
          Escribinos a <b>{constants.contactMail}</b> con
          la siguiente información:
          <ul>
            <li>Asunto <i>Recuperar cuenta</i></li>
            <li>Foto de tu CI</li>
            <li>La dirección de correo con la que pensás que estabas registrado</li>
            <li>Tu número de celular</li>
          </ul>
        </p>
        {/* <DataForm
          className={styles.form}
        /> */}
      </div>
    </div>
  );
});

export { RecoverAccount };



// WEBPACK FOOTER //
// ./src/pages/recover-account/RecoverAccount.jsx